<template>
    <div class="single-product__shipping">
        <ul class="single-product__shipping-item">
            <li v-for="(item, index) in dataShippingDesc" :key="index">
                <img 
                :src="`${baseUrl}api/wp-content/uploads/${item.image}`"
                :alt="item.title">
                <span class="single-product__shipping-item-description">{{item.title}}</span>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_shippingdes.scss";
</style>

<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
type ShippingItem = {
  image: string;
  title: string;
  link: string;
};

const props = defineProps<{
  dataShippingDesc: ShippingItem[];
}>();
    // import freeShipping from '@/assets/images/single-product/Free-Shipping.png';
    // import storePickup from '@/assets/images/single-product/Store-Pickup-Available.png';
    // import freeExchanges from '@/assets/images/single-product/7-Days-Free-Exchanges.png';
    // import certifiedGenuine from '@/assets/images/single-product/thumbnail_Certificate.png';

    // const data = [
    //     { "thumbnail" : freeShipping, "description" : "Free Shipping" },
    //     { "thumbnail" : storePickup, "description" : "Store Pickup Available"},
    //     { "thumbnail" : freeExchanges, "description" : "7 Days Free Exchanges"},
    //     { "thumbnail" : certifiedGenuine, "description" : "Authentic" },
    // ];
</script>
